import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Login    from './pages/Login';
import Home     from './pages/Home';
import Book     from './pages/Book';
import Messages from './pages/Messages';
import Nav      from './components/Nav';

export default function App() {
  const [user, setUser] = useState(undefined); // undefined = still loading

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => setUser(u));
    return unsub;
  }, []);

  if (user === undefined) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
        <div style={{ color:'var(--accent)', fontSize:18 }}>Loading…</div>
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <BrowserRouter>
      <div style={{ maxWidth:480, margin:'0 auto', minHeight:'100vh', paddingBottom:80 }}>
        <Routes>
          <Route path="/"         element={<Home />} />
          <Route path="/book"     element={<Book />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="*"         element={<Navigate to="/" />} />
        </Routes>
        <Nav />
      </div>
    </BrowserRouter>
  );
}
